import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MovimientoBienesRoutingModule } from './movimiento-bienes-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BajaBienesComponent } from './baja-bienes/baja-bienes.component';
import { ReactiveFormsModule } from '@angular/forms';
import {UiModule} from '@Components/ui/ui.module';
import { AccesoriosComponent } from './accesorios/accesorios.component';
import { DepreciationHistoryComponent } from './depreciation-history/depreciation-history.component';
import { FormAssetsComponent } from './form-assets/form-assets.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { NgxMatFileInputModule } from '@angular-material-components/file-input';
import { UtilModule } from '@Components/util/util.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormsModule } from '@angular/forms';
import { AssignResponsibleComponent } from './assign-responsible/assign-responsible.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MasterAssetsComponent } from './master-assets/master-assets.component';
import { ConsumptionReportComponent } from './consumption-report/consumption-report.component';
import { TableModule } from '@Components/table/table.module';
import { AssetsEntryFormComponent } from './assets-entry-form/assets-entry-form.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CxpAssetsFormComponent } from './cxp-assets-form/cxp-assets-form.component';

@NgModule({
  declarations: [BajaBienesComponent, AccesoriosComponent, DepreciationHistoryComponent, FormAssetsComponent,  AssignResponsibleComponent, MasterAssetsComponent, ConsumptionReportComponent, AssetsEntryFormComponent, CxpAssetsFormComponent],
    imports: [
        CommonModule,
        MovimientoBienesRoutingModule,
        ReactiveFormsModule,
        // mat
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        UiModule,
        MatDatepickerModule,
        MatSelectModule,
        MatProgressBarModule,
        MatDatetimepickerModule,
        MatTableModule,
        MatCardModule,
        MatDividerModule,
        NgxMatFileInputModule,
        UtilModule,
        MatExpansionModule,
        FormsModule,
        MatSlideToggleModule,
        MatSelectModule,
        TableModule,
        MatAutocompleteModule
    ],
    entryComponents: [DepreciationHistoryComponent],
    exports:[AssetsEntryFormComponent]
})
export class MovimientoBienesModule { }
